import Head from "next/head";
import { useRouter } from "next/router";
import Layout from "../components/Layout";
import TransactionHistoryV2 from "../components/TransactionHistoryV2";


export default function TransactionHistoryPage(props) {
  const router = useRouter();
  const { pathname } = router;
  return (
    <>
      <Head>
        <title>Job Hai - Transaction History</title>
      </Head>
      <Layout
        isFooter={false}
        isLogin={true}
        isHeaderFixed={true}
        pathname={pathname}
      >
        <TransactionHistoryV2 />
      </Layout>
    </>
  );
}
